$(document).ready(function () {
        $('.buildercheck').hover(function () {
            $(this).addClass('fa-times');
            $(this).removeClass('fa-check-circle'); 
            $(this).addClass('buildercross');
            $(this).removeClass('buildercheck'); 
        }, function () {
            $(this).addClass('fa-check-circle');
            $(this).removeClass('fa-times');
            $(this).addClass('buildercheck');
            $(this).removeClass('buildercross');
        });


    });

$(document).ready(function () {
        $('.inputcheck').hover(function () {
            $(this).addClass('fa-times');
            $(this).removeClass('fa-check-circle'); 
            $(this).addClass('inputcross');
            $(this).removeClass('inputcheck'); 
        }, function () {
            $(this).addClass('fa-check-circle');
            $(this).removeClass('fa-times');
            $(this).addClass('inputcheck');
            $(this).removeClass('inputcross');
        });


    });

$(document).ready(function () {
        $('.inputcheckS').hover(function () {
            $(this).addClass('fa-times');
            $(this).removeClass('fa-check-circle'); 
            $(this).addClass('inputcrossS');
            $(this).removeClass('inputcheckS'); 
        }, function () {
            $(this).addClass('fa-check-circle');
            $(this).removeClass('fa-times');
            $(this).addClass('inputcheckS');
            $(this).removeClass('inputcrossS');
        });


    });


$(window).on( "click keyup keydown keypress input mousemove mouseup load scroll", function() {
     
 if (document.getElementById("tab1").classList.contains("tab-current")){

        document.getElementById("btnNextxs").style.display = 'block';
        document.getElementById("BtnBack").style.display = 'none';
        document.getElementById("BtnBack2").style.display = 'none';
             document.getElementById("check11").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check11").setAttribute('style', 'color: #399639; margin-right: 10px;'); }
     
     if (document.getElementById("tab2").classList.contains("tab-current")){

       document.getElementById("btnNextxs").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';
            document.getElementById("check22").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check22").setAttribute('style', 'color: #399639; margin-right: 10px;'); }
     
     if (document.getElementById("tab3").classList.contains("tab-current")){

       document.getElementById("btnNextxs").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';
             document.getElementById("check33").setAttribute('style', 'color: white !important;');
      } else { document.getElementById("check33").setAttribute('style', 'color: #399639; margin-right: 10px;'); }


     
     if (document.getElementById("tab4").classList.contains("tab-current")){
        document.getElementById("btnNext").style.display = 'none';
       document.getElementById("btnNextxs").style.display = 'none';
       document.getElementById("AddtooCart").style.display = 'block';
       document.getElementById("BtnBack").style.display = 'block';
       document.getElementById("BtnBack2").style.display = 'block';

      }
 
   });
     
     



    function myFunctionBack() {
      

      if (document.getElementById("tab2").classList.contains("tab-current")){
      var on = "1";
      var off = "2";                 
      }
      if (document.getElementById("tab3").classList.contains("tab-current")){
      var on = "2";
      var off = "3"; 
      }
      if (document.getElementById("tab4").classList.contains("tab-current")){
      var on = "3";
      var off = "4";  
      }


        
      document.getElementById("tab"+on).className = "tab-current";
      document.getElementById("tab"+on).className += " active";
      document.getElementById('section-iconbox-'+on).className = "content-current";
      document.getElementById('section-iconbox-'+on).className += " active";
      
      document.getElementById('section-iconbox-'+off).className = "";
      document.getElementById('tab'+off).className = "";
      
      document.getElementById("AddtooCart").style.display = 'none';
      document.getElementById("btnNext").style.display = 'block';
        
      }
  
  
  
    function myFunctionNext() {
      
      
      if (document.getElementById("tab1").classList.contains("tab-current")){
      var on = "2";
      var off = "1";      

      } 
      if (document.getElementById("tab2").classList.contains("tab-current")){
      var on = "3";
      var off = "2";

      }
      if (document.getElementById("tab3").classList.contains("tab-current")){
      var on = "4";
      var off = "3";

      }
      if (document.getElementById("tab4").classList.contains("tab-current")){
      var on = "5";
      var off = "4"; 

      }
      

      
        
      document.getElementById("tab"+on).className = "tab-current";
      document.getElementById("tab"+on).className += " active";
      document.getElementById('section-iconbox-'+on).className = "content-current";
      document.getElementById('section-iconbox-'+on).className += " active";
      
      document.getElementById('section-iconbox-'+off).className = "";
      document.getElementById('tab'+off).className = "";
        
      }  

      
      function myFunctiontab1() {   
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-3').className = "";
      document.getElementById('section-iconbox-4').className = "";  
      document.getElementById('tab2').className = "";
      document.getElementById('tab3').className = "";
      document.getElementById('tab4').className = "";
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
        
      }
  
      function myFunctiontab2() {   
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-3').className = "";
      document.getElementById('section-iconbox-4').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab3').className = "";
      document.getElementById('tab4').className = "";
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
      }
      
      function myFunctiontab3() { 
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-4').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab2').className = "";
      document.getElementById('tab4').className = "";
        document.getElementById("AddtooCart").style.display = 'none';
       document.getElementById("btnNext").style.display = 'block';
      }
  
      function myFunctiontab4() { 
      document.getElementById('section-iconbox-1').className = "";
      document.getElementById('section-iconbox-2').className = "";
      document.getElementById('section-iconbox-3').className = "";  
      document.getElementById('tab1').className = "";
      document.getElementById('tab2').className = "";
      document.getElementById('tab3').className = "";
        document.getElementById("AddtooCart").style.display = 'block';
      }
      






